const Logo = ()=> {
  return (
    <img className="logo" src="/images/maine_coon_logo.png" alt="Maine Coon Logo" />
  )
}

export default Logo;